import { render, staticRenderFns } from "./AdsorptionForce3.vue?vue&type=template&id=13032dd8&scoped=true"
import script from "./AdsorptionForce3.vue?vue&type=script&lang=js"
export * from "./AdsorptionForce3.vue?vue&type=script&lang=js"
import style0 from "./AdsorptionForce3.vue?vue&type=style&index=0&id=13032dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13032dd8",
  null
  
)

export default component.exports